const TOURNAMENT = {
  STAKE_OPTIONS: "stake-options",
  TOURNAMENT_PARTICIPANTS: "tournament-participants",
  DUEL_ENTRY: "duel-entry",
  DUEL_OPPONENT: "duel-opponent",
  TOURNAMENT_DETAILS: "tournament-details",
  MULTIPLAYER_TOURNAMENTS: "multiplayer-tournaments",
  ACTIVE_TOURNAMENTS: "active-tournaments",
  RECENT_GAMERS_SUMMARY: "recent-gamers-summary",
  CANCEL_ENTRY: "cancel-entry",
  PLAY_PRACTICE_GAME: "play-practice-game",
  ENTRY_DETAILS: "entry-details",
  ENTRY_LIST: "entry-list",
  FORFEIT_ENTRY: "forfeit-entry",
  LATEST_WINNERS: "latest-winners",
} as const;

const GAME = {
  GAME_DETAILS: "game-details",
  ALL_GAMES: "all-games",
  MY_TOP_GAMES: "my-top-games",
  POPULAR_GAMES: "popular-games",
  MY_FAVORITE_GAMES: "my-favorite-games",
  GAME_CATEGORIES: "game-categories",
  MY_DEFAULT_GAME: "my-default-game",
} as const;

const WALLET = {
  WALLET_LIST: "wallet-list",
  GEM_RESPONSE: "gem-response",
  PURCHASE_PLANS: "purchase-plans",
  EXCHANGE_RATES: "exchange-rates",
  PAYMENT_PROVIDERS: "payment-providers",
};

const CHALLENGE = {
  CHALLENGE_INVITATIONS: "challenge-invitations",
  PENDING: "pending-challenges",
};

const CONFIGURATIONS = {
  SOCIAL_LINKS_BY_COUNTRY: "social-links-by-country",
};

const USER = {
  PROFILE: "user-profile",
  VERIFICATION_STATUS: "verification-status",
};

const ATTRIBUTION = {
  SAVE: "save-attribution",
  SAVE_PHOENIX_CLICK: "save-phoenix-click",
} as const;

export const QUERY_KEYS = {
  TOURNAMENT,
  GAME,
  WALLET,
  CHALLENGE,
  CONFIGURATIONS,
  USER,
  ATTRIBUTION,
} as const;
